module.exports = __webpack_public_path__ + "img/Qin_Jin@2x.81d8a33c.png";